module.exports = __webpack_public_path__ + "static/039.thumb-205643304f00b5e61302e49a50d97a18.jpg";